// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ASK_AN_EXPERT = "Poradne";
export const BACK_TO_TOPICS = "Sp\u00e4\u0165 na f\u00f3ra";
export const COUNSELLING_IS_ARCHIVED = "Porad\u0148a je uzavret\u00e1";
export const FORUM = "F\u00f3ra";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00fa ot\u00e1zku";
export const PREGNANCY_NEWSLETTER = "Tehotensk\u00fd newsletter";
export const PREGNANCY_NEWSLETTER_DESCRIPTION = "Ka\u017ed\u00fd t\u00fd\u017ede\u0148 dostane\u0161 najd\u00f4le\u017eitej\u0161ie info do e-mailu";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR = "Tehotenskej kalkula\u010dke";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_01 = "Nepozn\u00e1\u0161 t\u00fd\u017ede\u0148 tehotenstva? Vypo\u010d\u00edtaj si ho v";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH = "Tehotenskej kalkula\u010dke";
export const PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH_01 = "Nepozn\u00e1\u0161 term\u00edn p\u00f4rodu? Vypo\u010d\u00edtaj si ho v";
export const PREGNANCY_WEEKS_BOX_01 = "Zisti viac o svojom tehotenstve:";
export const PREGNANCY_WEEKS_BOX_02 = "Tehotenstvo t\u00fd\u017ede\u0148 po t\u00fd\u017edni";
export const REPORTED_COMMENTS = "Nahl\u00e1sen\u00e9 koment\u00e1re";
export const WIKI_REVIEWS = "Centrum recenzi\u00ed";
